import * as React from 'react'
import handleViewport from 'react-in-viewport'

import { OutOfStockNotification } from '@thg-commerce/enterprise-components/OutOfStockNotification'
import { VariantFields } from '@thg-commerce/enterprise-components/src/transformer/productOptionsTransformer'
import {
  useCustomer,
  useRequestConfig,
  useSiteConfig,
  useSiteDefinition,
} from '@thg-commerce/enterprise-core'
import { Margin } from '@thg-commerce/gravity-theme/margin'

import { useProductPage } from '../../context'

interface OutOfStockNotificationRendererProps {
  mainProduct?: boolean
  selectedVariant?: VariantFields
  url?: string
  styleOverride?: {
    margin: Margin
  }
}

export const OutOfStockNotificationRenderer = (
  props: OutOfStockNotificationRendererProps,
) => {
  const {
    showOutOfStockNotification,
    enablePushNotifyWhenInStock,
    showOOSNotificationBelowOptions,
  } = useSiteConfig()
  const { domain } = useSiteDefinition()
  const { selectedVariant, product } = useProductPage()
  const { isMobileApp } = useRequestConfig()
  const customer = useCustomer()
  const ref = React.useRef<HTMLDivElement>(null)

  const selectedVariantValue = props.mainProduct
    ? selectedVariant
    : props.selectedVariant
  const productUrl = props.mainProduct ? product?.url : props.url

  const hasPushNotificationEnabled =
    enablePushNotifyWhenInStock &&
    isMobileApp &&
    selectedVariantValue?.notifyWhenInStockEnabled &&
    !selectedVariantValue.inStock

  if (
    !showOutOfStockNotification ||
    !(
      selectedVariantValue &&
      !selectedVariantValue?.inStock &&
      selectedVariantValue?.notifyWhenInStockEnabled
    ) ||
    hasPushNotificationEnabled
  ) {
    return null
  }

  const OutOfStockNotificationViewport = handleViewport(OutOfStockNotification)

  return !showOOSNotificationBelowOptions ? (
    <OutOfStockNotificationViewport
      email={customer?.email}
      sku={selectedVariantValue.sku}
      url={`https://${domain}${productUrl}`}
      defaultOptInChecked={
        customer?.emailMarketingPreference ||
        customer?.smsMarketingPreference ||
        false
      }
      styleOverride={props.styleOverride}
    />
  ) : (
    <OutOfStockNotification
      email={customer?.email}
      sku={selectedVariantValue.sku}
      url={`https://${domain}${productUrl}`}
      defaultOptInChecked={
        customer?.emailMarketingPreference ||
        customer?.smsMarketingPreference ||
        false
      }
      styleOverride={props.styleOverride}
      inViewport={true}
      enterCount={0}
      forwardedRef={ref}
    />
  )
}
